import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsFormat',
    standalone: false,
})
export class ThousandsFormatPipe implements PipeTransform {

  transform(value: string): any {

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  }

}
